import { cva } from 'class-variance-authority'

export const swatchVariants = cva('inline-block shrink-0 rounded-sm', {
  variants: {
    size: {
      small: 'size-2',
      default: 'size-3',
    },
  },
  defaultVariants: {
    size: 'default',
  },
})
